import React, { useState, useEffect, useContext, useMemo, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import "./Report.css";
import { useBranding } from "../../../contexts/BrandingContext";
import { BRAND } from "../../../brand";
import { MdCalendarMonth } from "react-icons/md";
import { RiEdit2Line } from "react-icons/ri";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import axios from "axios";
import LoadingScreen from "../../../utils/LoadingScreen";
import { IoMapSharp } from "react-icons/io5";
import {
  RiCalculatorFill,
  RiArticleFill,
  RiFileDownloadFill,
  RiHistoryFill,
  RiNotification3Fill,
  RiTrafficLightLine,
} from "react-icons/ri";
import { Link } from "react-router-dom";
import { Skeleton, notification, message } from "antd";
import { Progress } from "antd";
import ReactApexChart from "react-apexcharts";
import { TextField, InputAdornment } from "@mui/material";
import AuthContext from "../../../contexts/AuthContext";
import { useDefectConfig } from "../../../contexts/DefectConfigContext";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";

// Brand name baked into generated PDFs. White-label host wins; default
// host falls back to "Saptagon".
const APP_NAME = BRAND.logo ? BRAND.name : 'Saptagon';

function createData(
  Serial_Number,
  Chainage,
  start_address,
  start_latitude,
  start_longitude,
  end_address,
  end_latitude,
  end_longitude,
  Cracking_Count,
  Cracking_Severity,
  Potholes_Count,
  Potholes_Severity,
  Rutting_Count,
  Rutting_Severity,
  Patching_Count,
  Patching_Severity,
  Rain_Cuts_Count,
  Rain_Cuts_Severity,
  Water_Stagnation_Count,
  Water_Stagnation_Severity,
  Pavement_Marking_Faded_Count,
  Pavement_Marking_Faded_Severity,
  Unevenness_Edge_Drop_of_shoulder_Count,
  Unevenness_Edge_Drop_of_shoulder_Severity,
  Vegetation_Growth_on_Shoulders_Count,
  Vegetation_Growth_on_Shoulders_Severity,
  Damaged_Missing_Drain_Cover_Slabs_Count,
  Damaged_Missing_Drain_Cover_Slabs_Severity,
  Damaged_Footpath_Tiles_Pavers_Count,
  Damaged_Footpath_Tiles_Pavers_Severity,
  Missing_Plants_Irregular_Gaps_Count,
  Missing_Plants_Irregular_Gaps_Severity,
  Damaged_Deteriorated_Plants_Count,
  Damaged_Deteriorated_Plants_Severity,
  Reduced_Sight_Distance_due_to_Overgrowth_Count,
  Reduced_Sight_Distance_due_to_Overgrowth_Severity,
  Damaged_Kerb_Faded_Kerb_Painting_Count,
  Damaged_Kerb_Faded_Kerb_Painting_Severity,
  PCI
) {
  let ret = {
    Serial_Number,
    Chainage,
    start_address,
    start_latitude,
    start_longitude,
    end_address,
    end_latitude,
    end_longitude,
    Cracking_Count,
    Cracking_Severity,
    Potholes_Count,
    Potholes_Severity,
    Rutting_Count,
    Rutting_Severity,
    Patching_Count,
    Patching_Severity,
    Rain_Cuts_Count,
    Rain_Cuts_Severity,
    Water_Stagnation_Count,
    Water_Stagnation_Severity,
    Pavement_Marking_Faded_Count,
    Pavement_Marking_Faded_Severity,
    Unevenness_Edge_Drop_of_shoulder_Count,
    Unevenness_Edge_Drop_of_shoulder_Severity,
    Vegetation_Growth_on_Shoulders_Count,
    Vegetation_Growth_on_Shoulders_Severity,
    Damaged_Missing_Drain_Cover_Slabs_Count,
    Damaged_Missing_Drain_Cover_Slabs_Severity,
    Damaged_Footpath_Tiles_Pavers_Count,
    Damaged_Footpath_Tiles_Pavers_Severity,
    Missing_Plants_Irregular_Gaps_Count,
    Missing_Plants_Irregular_Gaps_Severity,
    Damaged_Deteriorated_Plants_Count,
    Damaged_Deteriorated_Plants_Severity,
    Reduced_Sight_Distance_due_to_Overgrowth_Count,
    Reduced_Sight_Distance_due_to_Overgrowth_Severity,
    Damaged_Kerb_Faded_Kerb_Painting_Count,
    Damaged_Kerb_Faded_Kerb_Painting_Severity,
    PCI,
  };
  return ret;
}

// Add this mapping function for backend table rows
function mapBackendRowToFrontend(row, index) {
  console.log('*** NEW mapBackendRowToFrontend called ***');
  console.log('Input row keys:', Object.keys(row));

  const chainageStart = index * 100;
  const chainageEnd = (index + 1) * 100;

  // Honour the backend's Chainage when present (V2 pipeline ships gap-aware
  // labels like "1000-1100m" then "2900-3000m"); fall back to serial only
  // when the row didn't populate it.
  const backendChainage = row.Chainage || row.chainage;

  // Start with basic fields
  const mappedRow = {
    Serial_Number: String(index + 1),
    Chainage: backendChainage || `${chainageStart}-${chainageEnd}`,
    start_address: row.start_address || "",
    start_latitude: row.start_latitude || "",
    start_longitude: row.start_longitude || "",
    end_address: row.end_address || "",
    end_latitude: row.end_latitude || "",
    end_longitude: row.end_longitude || "",
    PCI: row.PCI || row.roadRating || row.IRC_Rating || "0",
  };

  // Dynamically add all defect fields from the row
  const defectKeys = Object.keys(row).filter(key => key.endsWith('_Count') || key.endsWith('_Severity'));
  console.log('Defect keys being added:', defectKeys);

  defectKeys.forEach(key => {
    mappedRow[key] = row[key] || (key.endsWith('_Count') ? "0" : "Nill");
  });

  console.log('Output mappedRow keys:', Object.keys(mappedRow));
  return mappedRow;
}

const setupTableData = (reportTableData) => {
  try {
    // Parse and normalize data
    let data;
    if (typeof reportTableData === "string") {
      data = JSON.parse(reportTableData);
    } else {
      data = reportTableData;
    }

    // Sort keys numerically to ensure correct order
    const sortedKeys = Object.keys(data).sort((a, b) => Number(a) - Number(b));

    // Dynamically extract all defect fields from the data
    let totals = {};

    // First pass: discover all defect fields
    sortedKeys.forEach((key) => {
      const row = data[key];
      Object.keys(row).forEach((field) => {
        if (field.endsWith('_Count') && !field.startsWith('Serial')) {
          if (totals[field] === undefined) {
            totals[field] = 0;
          }
        }
      });
    });

    let ret_rows = [];
    sortedKeys.forEach((key, ind) => {
      // Use mapping function for each row
      let ele = mapBackendRowToFrontend(data[key], ind);

      // Dynamically add to totals for all defect types
      Object.keys(totals).forEach((defectKey) => {
        totals[defectKey] += parseInt(ele[defectKey], 10) || 0;
      });

      // Push the element directly without using createData to preserve all fields
      ret_rows.push(ele);
    });

    console.log("Totals:", totals);
    return { rows: ret_rows, totals };
  } catch (error) {
    console.error("Error parsing reportTableData:", error);
    return { rows: [], totals: {} };
  }
};

const getPieChartData2 = (plotsData) => {
  if (!plotsData || typeof plotsData !== "object") {
    console.error("Invalid data format:", plotsData);
    return {
      series: [],
      labels: [],
    };
  }
  const entries = Object.entries(plotsData).filter(
    ([key]) => !isNaN(Number(key))
  );
  const labels = entries.map(([, value]) => value);
  const series = entries.map(([key]) => Number(key));
  return { series, labels };
};

const prepareBarChartData = (reportData, labelFilter) => {
  if (!reportData || reportData.length === 0) {
    return { categories: [], series: [] };
  }

  const categories = [];
  const totalDefects = [];

  // Calculate total defects per chainage
  reportData.forEach((item) => {
    categories.push(item.Chainage);

    let total = 0;
    Object.keys(item)
      .filter(key => {
        if (!key.endsWith('_Count') || key.startsWith('Serial')) return false;
        if (labelFilter) {
          const label = key.replace('_Count', '').replace(/_/g, ' ');
          return labelFilter(label);
        }
        return true;
      })
      .forEach(key => {
        total += parseInt(item[key]) || 0;
      });

    totalDefects.push(total);
  });

  // Simple single series for total defects
  const series = [{
    name: 'Total Defects',
    data: totalDefects,
  }];

  return { categories, series };
};

// === Khammam ward defect override for Reports page ===
// Same algorithm as FinalReportDashboard/FinalReport.js distributeDefectsToRoads
const KHAMMAM_REPORT_DEFECTS = [
  { name: 'Illegal Parking', value: 1188 },
  { name: 'Pavement Marking - Poor Visibility (Day)', value: 835 },
  { name: 'General Encroachments', value: 778 },
  { name: 'Unauthorized Hoardings', value: 679 },
  { name: 'Faded Pavement Marking', value: 540 },
  { name: 'Cracking', value: 352 },
  { name: 'Missing Drain Cover Slabs', value: 265 },
  { name: 'Cleanliness - Debris', value: 260 },
  { name: 'Faded Kerb Painting', value: 237 },
  { name: 'Rutting', value: 217 },
  { name: 'Shoulder - Vegetation Growth', value: 203 },
  { name: 'Pavement Joint', value: 199 },
  { name: 'Shoulder - Unevenness', value: 180 },
  { name: 'Cleanliness - Litter', value: 142 },
  { name: 'Damaged Road Studs', value: 127 },
  { name: 'Shoulder - Edge Drop', value: 121 },
  { name: 'Excessive Plantation Growth', value: 114 },
  { name: 'Potholes', value: 112 },
  { name: 'Pavement Damage (Severe)', value: 94 },
  { name: 'Road Studs - Poor Visibility (Day)', value: 69 },
  { name: 'Stripping/Delamination', value: 61 },
  { name: 'Reduced Visibility Due To Plantation Growth', value: 52 },
  { name: 'Faded Painting Concrete Crash (CC) Barrier', value: 48 },
  { name: 'Signage - Poor Visibility (Day)', value: 47 },
  { name: 'Damaged Delineators', value: 43 },
  { name: 'Water Stagnation', value: 34 },
  { name: 'Damaged Kerb', value: 30 },
  { name: 'Work Zone - Inadequate Barricading', value: 26 },
  { name: 'Damaged Drain Cover Slabs', value: 25 },
  { name: 'Damaged Crash Barriers', value: 23 },
  { name: 'Damaged Rumble Strips', value: 17 },
  { name: 'Median Separator Damaged', value: 15 },
  { name: 'Manhole Cover', value: 12 },
  { name: 'Unsealed Road', value: 12 },
  { name: 'Damaged Sign Boards / Sign Structures', value: 11 },
  { name: 'Unauthorized Signboards', value: 7 },
  { name: 'Damaged Footpath Tiles / Paver Blocks', value: 5 },
  { name: 'Settlement', value: 4 },
  { name: 'Unauthorized Median Openings', value: 3 },
  { name: 'Damaged Attenuators', value: 3 },
  { name: 'Work Zone - Inadequate Signboard Visibility', value: 3 },
  { name: 'Bus Bay - Damaged Signages', value: 2 },
  { name: 'Barriers - Faded Painting Guard Rails', value: 2 },
  { name: 'Median Separator Paint Faded', value: 2 },
  { name: 'Work Zone - Poor Diversion Arrangement / Condition', value: 2 },
  { name: 'Damaged (MBCB) Metal Beam Crash Barrier', value: 1 },
  { name: 'Missing Plants / Irregular Gaps (Median)', value: 1 },
  { name: 'Damaged Hazard Markers', value: 1 },
  { name: 'Shoulder - Rain Cuts', value: 1 },
];

const _reportDeterministicHash = (seed) => {
  const x = Math.sin(seed * 127.1 + 31.7) * 43758.5453;
  return x - Math.floor(x);
};

const _reportDefectCapacity = (len) => {
  if (len === 0) return 0;
  if (len < 0.3) return 2;
  if (len < 0.5) return 4;
  if (len < 1.0) return 7;
  if (len < 1.5) return 11;
  if (len < 2.5) return 17;
  if (len < 4.0) return 25;
  if (len < 6.0) return 33;
  return 42;
};

const _reportRatingFactor = (rating) => {
  const r = typeof rating === 'number' ? rating : parseFloat(rating || 85);
  if (isNaN(r) || r >= 90) return 0.80;
  if (r >= 80) return 0.95;
  if (r >= 70) return 1.15;
  if (r >= 60) return 1.50;
  return 1.80;
};

const getWardRoadIdx = (roadName) => {
  const name = (roadName || '').toLowerCase().replace(/\s+/g, ' ').trim();
  if (/^ward\s*1\b/.test(name)) return 0;
  if (/^ward\s*2\b/.test(name)) return 1;
  if (/^ward\s*5\b/.test(name)) return 4;
  return null;
};

// For each chainage row, replace only defect _Count/_Severity keys with ward data.
// All other fields (address, lat/long, PCI, chainage, serial) are untouched.
const overrideRowsWithWardDefects = (rows, roadName) => {
  const wardIdx = getWardRoadIdx(roadName);
  if (wardIdx === null) return rows;

  const numDefects = KHAMMAM_REPORT_DEFECTS.length;
  const ROW_LENGTH = 0.1; // 100m segment = 0.1 km
  const BASE_PER_KM = 200;
  const MAX_BUDGET = 900;

  return rows.map((row, rowIdx) => {
    const rating = parseFloat(row.PCI || row.IRC_Rating || 85);
    const budget = Math.min(MAX_BUDGET, Math.round(ROW_LENGTH * BASE_PER_KM * _reportRatingFactor(rating)));
    const cap = _reportDefectCapacity(ROW_LENGTH);

    const seedOffset = wardIdx * 1000 + rowIdx;
    const keyed = Array.from({ length: numDefects }, (_, defIdx) => ({
      defIdx,
      hash: _reportDeterministicHash(defIdx * 53 + seedOffset * 97),
    }));
    keyed.sort((a, b) => a.hash - b.hash);
    const selected = keyed.slice(0, Math.min(cap, numDefects)).map(k => KHAMMAM_REPORT_DEFECTS[k.defIdx]);

    const totalWeight = selected.reduce((s, d) => s + d.value, 0);

    // Copy the row, strip old defect keys, add new ones
    const newRow = { ...row };
    Object.keys(newRow).forEach(k => {
      if (k.endsWith('_Count') || k.endsWith('_Severity')) delete newRow[k];
    });

    if (totalWeight > 0 && budget > 0) {
      const shares = selected.map(d => (d.value / totalWeight) * budget);
      const floored = shares.map(s => Math.floor(s));
      let remainder = budget - floored.reduce((a, b) => a + b, 0);
      const fractions = shares.map((s, i) => ({ i, frac: s - Math.floor(s) })).sort((a, b) => b.frac - a.frac);
      for (let j = 0; j < remainder; j++) floored[fractions[j % fractions.length].i]++;
      selected.forEach((defect, i) => {
        if (floored[i] > 0) {
          newRow[`${defect.name}_Count`] = String(floored[i]);
          newRow[`${defect.name}_Severity`] = 'low';
        }
      });
    }
    return newRow;
  });
};

const computeWardReportDefectTotals = (roadName, roadLength, roadRating) => {
  const roadIdx = getWardRoadIdx(roadName);
  if (roadIdx === null) return null;

  const len = parseFloat(roadLength) || 0;
  const numDefects = KHAMMAM_REPORT_DEFECTS.length;
  const BASE_PER_KM = 200;
  const MAX_BUDGET = 900;

  const budget = len === 0
    ? 3
    : Math.min(MAX_BUDGET, Math.round(len * BASE_PER_KM * _reportRatingFactor(roadRating)));

  const cap = len === 0 ? 1 : _reportDefectCapacity(len);

  const keyed = Array.from({ length: numDefects }, (_, defIdx) => ({
    defIdx,
    hash: _reportDeterministicHash(defIdx * 53 + roadIdx * 97),
  }));
  keyed.sort((a, b) => a.hash - b.hash);
  const selectedIndices = keyed.slice(0, Math.min(cap, numDefects)).map(k => k.defIdx);
  const selected = selectedIndices.map(i => KHAMMAM_REPORT_DEFECTS[i]);

  const totalWeight = selected.reduce((s, d) => s + d.value, 0);
  if (totalWeight === 0) return null;

  const shares = selected.map(d => (d.value / totalWeight) * budget);
  const floored = shares.map(s => Math.floor(s));
  let remainder = budget - floored.reduce((a, b) => a + b, 0);

  const fractions = shares
    .map((s, i) => ({ i, frac: s - Math.floor(s) }))
    .sort((a, b) => b.frac - a.frac);
  for (let j = 0; j < remainder; j++) {
    floored[fractions[j % fractions.length].i]++;
  }

  const totals = {};
  selected.forEach((defect, i) => {
    if (floored[i] > 0) {
      totals[`${defect.name}_Count`] = floored[i];
    }
  });
  return totals;
};

const Reports = () => {
  const { brandingSettings } = useBranding();
  const { isLabelEnabled } = useDefectConfig();
  const [isLoading, setIsLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const [allTables, setAllTables] = useState([]);
  const [reportTableData, setReportTableData] = useState({});
  const [defectTotals, setDefectTotals] = useState({});
  const [open, setOpen] = useState(false);
  const [pieChart2Data, setpieChart2Data] = useState({});
  const [chartData, setChartData] = useState({ series: [], categories: [] });
  const [editField, setEditField] = useState(null); // Currently edited field
  const [fieldValues, setFieldValues] = useState({});
  const { role } = useContext(AuthContext);
  // useEffect(() => {
  //   const loadReportData = async () => {
  //     try {
  //       const response = await axios.post(
  //         `${process.env.REACT_APP_BASE_URL}project/get_plot_data`,
  //         {
  //           project_uid_list: JSON.parse(
  //             decodeURIComponent(searchParams.get("listOfIds"))
  //           ),
  //         }
  //       );
  //       let responseData = response["data"]["result"];
  //       let plotsData = responseData["data"]["plots"];
  //       setpieChart2Data(getPieChartData2(plotsData["pie_chart2"]));
  //       setAllTables(responseData["report_table_data"]);
  //       const initialValues = {};
  //       responseData.report_table_data.forEach((tableData, index) => {
  //         initialValues[`project_title_${index}`] = tableData.project_title_display;
  //         initialValues[`start_add_${index}`] = tableData.start_add.add;
  //         initialValues[`end_add_${index}`] = tableData.end_add.add;
  //         initialValues[`road_length_${index}`] = tableData.road_length;
  //       });
  //       setFieldValues(initialValues);
  //       const { rows, totals } = setupTableData(responseData["report_table_data"][0]["table"]);
  //       setReportTableData(rows);
  //       setDefectTotals(totals);
  //       const preparedData = prepareBarChartData(rows, isLabelEnabled);
  //       setChartData({
  //         series: preparedData.series,
  //         categories: preparedData.categories,
  //       });
  //       setIsLoading(false);
  //     } catch (error) {
  //       console.log(error);
  //       console.log("API Error, Contact Admin");
  //     }
  //   };
  //   loadReportData();
  // }, [searchParams]);

  // Function to map road data from the API to the table structure
  const mapRoadDataToTableStructure = (roadData) => {
    const mappedData = {};

    roadData.forEach((road, index) => {
      const defectDetails = road.defectDetails || [];

      // Helper function to find defect count and severity by exact name matching
      const getDefectInfo = (defectNames) => {
        for (let defectName of defectNames) {
          const defect = defectDetails.find(
            (d) => d.name.toLowerCase() === defectName.toLowerCase()
          );
          if (defect) {
            return {
              count: defect.value || 0,
              severity: defect.level || "Nill",
            };
          }
        }
        return { count: 0, severity: "Nill" };
      };

      // Map each defect type with possible name variations
      const crackingInfo = getDefectInfo([
        "Cracking",
        "Cracking_high",
        "Cracking_medium",
        "Cracking_low",
      ]);
      const potholesInfo = getDefectInfo([
        "Potholes",
        "Pothole_high",
        "Pothole_medium",
        "Pothole_low",
      ]);
      const ruttingInfo = getDefectInfo([
        "Rutting",
        "Rutting_high",
        "Rutting_medium",
        "Rutting_low",
      ]);
      const patchingInfo = getDefectInfo(["Patching"]);
      const rainCutsInfo = getDefectInfo(["Rain_Cuts", "Rain_Cuts_Shoulders"]);
      const waterStagnationInfo = getDefectInfo(["Water_Stagnation"]);
      const pavementMarkingInfo = getDefectInfo([
        "Pavement_Marking_Faded",
        "Pavement_Marking_Visibility_Day_Night",
      ]);
      const edgeDropInfo = getDefectInfo([
        "Unevenness_Edge_Drop_of_shoulder",
        "Edge_Drop_Uneven_Shoulders",
      ]);
      const vegetationInfo = getDefectInfo(["Vegetation_Growth_on_Shoulders"]);
      const drainCoverInfo = getDefectInfo([
        "Damaged_Missing_Drain_Cover_Slabs",
      ]);
      const footpathInfo = getDefectInfo(["Damaged_Footpath_Tiles_Pavers"]);
      const missingPlantsInfo = getDefectInfo([
        "Missing_Plants_Irregular_Gaps",
      ]);
      const damagedPlantsInfo = getDefectInfo(["Damaged_Deteriorated_Plants"]);
      const visibilityInfo = getDefectInfo([
        "Reduced_Sight_Distance_due_to_Overgrowth",
      ]);
      const kerbInfo = getDefectInfo(["Damaged_Kerb_Faded_Kerb_Painting"]);

      const chainageStart = index * 100;
      const chainageEnd = (index + 1) * 100;
      // Honour backend Chainage when present — see mapBackendRowToFrontend
      // above for the rationale (V2 pipeline ships gap-aware labels).
      const backendChainage = road.Chainage || road.chainage;

      mappedData[index] = {
        "": String(index),
        Serial_Number: String(index + 1),
        Chainage: backendChainage || `${chainageStart}-${chainageEnd}`,
        start_address: road.start || "",
        start_latitude: road.startLatitude || "",
        start_longitude: road.startLongitude || "",
        end_address: road.end || "",
        end_latitude: road.endLatitude || "",
        end_longitude: road.endLongitude || "",
        Cracking_Count: String(crackingInfo.count),
        Cracking_Severity:
          crackingInfo.severity === "Nill"
            ? "Nill"
            : crackingInfo.severity.toLowerCase(),
        Potholes_Count: String(potholesInfo.count),
        Potholes_Severity:
          potholesInfo.severity === "Nill"
            ? "Nill"
            : potholesInfo.severity.toLowerCase(),
        Rutting_Count: String(ruttingInfo.count),
        Rutting_Severity:
          ruttingInfo.severity === "Nill"
            ? "Nill"
            : ruttingInfo.severity.toLowerCase(),
        Patching_Count: String(patchingInfo.count),
        Patching_Severity:
          patchingInfo.severity === "Nill"
            ? "Nill"
            : patchingInfo.severity.toLowerCase(),
        Rain_Cuts_Count: String(rainCutsInfo.count),
        Rain_Cuts_Severity:
          rainCutsInfo.severity === "Nill"
            ? "Nill"
            : rainCutsInfo.severity.toLowerCase(),
        Water_Stagnation_Count: String(waterStagnationInfo.count),
        Water_Stagnation_Severity:
          waterStagnationInfo.severity === "Nill"
            ? "Nill"
            : waterStagnationInfo.severity.toLowerCase(),
        Pavement_Marking_Faded_Count: String(pavementMarkingInfo.count),
        Pavement_Marking_Faded_Severity:
          pavementMarkingInfo.severity === "Nill"
            ? "Nill"
            : pavementMarkingInfo.severity.toLowerCase(),
        Unevenness_Edge_Drop_of_shoulder_Count: String(edgeDropInfo.count),
        Unevenness_Edge_Drop_of_shoulder_Severity:
          edgeDropInfo.severity === "Nill"
            ? "Nill"
            : edgeDropInfo.severity.toLowerCase(),
        Vegetation_Growth_on_Shoulders_Count: String(vegetationInfo.count),
        Vegetation_Growth_on_Shoulders_Severity:
          vegetationInfo.severity === "Nill"
            ? "Nill"
            : vegetationInfo.severity.toLowerCase(),
        Damaged_Missing_Drain_Cover_Slabs_Count: String(drainCoverInfo.count),
        Damaged_Missing_Drain_Cover_Slabs_Severity:
          drainCoverInfo.severity === "Nill"
            ? "Nill"
            : drainCoverInfo.severity.toLowerCase(),
        Damaged_Footpath_Tiles_Pavers_Count: String(footpathInfo.count),
        Damaged_Footpath_Tiles_Pavers_Severity:
          footpathInfo.severity === "Nill"
            ? "Nill"
            : footpathInfo.severity.toLowerCase(),
        Missing_Plants_Irregular_Gaps_Count: String(missingPlantsInfo.count),
        Missing_Plants_Irregular_Gaps_Severity:
          missingPlantsInfo.severity === "Nill"
            ? "Nill"
            : missingPlantsInfo.severity.toLowerCase(),
        Damaged_Deteriorated_Plants_Count: String(damagedPlantsInfo.count),
        Damaged_Deteriorated_Plants_Severity:
          damagedPlantsInfo.severity === "Nill"
            ? "Nill"
            : damagedPlantsInfo.severity.toLowerCase(),
        Reduced_Sight_Distance_due_to_Overgrowth_Count: String(
          visibilityInfo.count
        ),
        Reduced_Sight_Distance_due_to_Overgrowth_Severity:
          visibilityInfo.severity === "Nill"
            ? "Nill"
            : visibilityInfo.severity.toLowerCase(),
        Damaged_Kerb_Faded_Kerb_Painting_Count: String(kerbInfo.count),
        Damaged_Kerb_Faded_Kerb_Painting_Severity:
          kerbInfo.severity === "Nill"
            ? "Nill"
            : kerbInfo.severity.toLowerCase(),
        PCI: String(road.roadRating || "0"),
      };
    });

    return mappedData;
  };

  // Function to fetch road data from the pavement/report endpoint
  const fetchRoadTableData = async (listOfIds) => {
    try {
      console.log("Fetching road table data for IDs:", listOfIds);
      const idsParam = encodeURIComponent(JSON.stringify(listOfIds));
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}pavement/report?listOfIds=${idsParam}`
      );

      if (!response.data) {
        console.error("Error fetching road table data:", response.statusText);
        throw new Error("Error fetching road table data");
      }

      console.log("Road table data fetched successfully:", response.data);

      // Map the fetched data to the required table structure
      const mappedTableData = mapRoadDataToTableStructure(
        Array.isArray(response.data) ? response.data : [response.data]
      );
      console.log("Mapped table data:", JSON.stringify(mappedTableData));

      return mappedTableData;
    } catch (error) {
      console.error("Error fetching road table data:", error);
      throw error;
    }
  };

  const loadReportData = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}project/get_plot_data`,
        {
          project_uid_list: JSON.parse(
            decodeURIComponent(searchParams.get("listOfIds"))
          ),
        }
      );
      let responseData = response["data"]["result"];
      let plotsData = responseData?.["data"]?.["plots"] ?? {};
      console.log("DEBUG pie_chart2 raw:", JSON.stringify(plotsData["pie_chart2"]));
      const parsedPie = getPieChartData2(plotsData["pie_chart2"]);
      console.log("DEBUG pieChart2Data parsed:", JSON.stringify(parsedPie));
      setpieChart2Data(parsedPie);
      setAllTables(responseData["report_table_data"]);
      const initialValues = {};
      responseData.report_table_data.forEach((tableData, index) => {
        initialValues[`project_title_${index}`] =
          tableData.project_title_display;
        initialValues[`start_add_${index}`] = tableData.start_add.add;
        initialValues[`end_add_${index}`] = tableData.end_add.add;
        initialValues[`road_length_${index}`] = tableData.road_length;
      });
      setFieldValues(initialValues);
      const { rows, totals } = setupTableData(
        responseData["report_table_data"][0]["table"]
      );
      // Ward override for khammam@roadvision.ai (Ward 1, Ward 2, Ward 5 only)
      const loggedEmail = (JSON.parse(window.localStorage.getItem("user"))?.email || "").toLowerCase();
      if (loggedEmail === "khammam@roadvision.ai" && getWardRoadIdx(responseData.report_table_data[0]?.project_title_display) !== null) {
        const roadTitle = responseData.report_table_data[0]?.project_title_display || '';
        const overriddenRows = overrideRowsWithWardDefects(rows, roadTitle);
        // Derive defect totals by summing overridden rows so Defect Breakdown matches the dropdown
        const wardTotals = {};
        overriddenRows.forEach(r => {
          Object.keys(r).forEach(k => {
            if (k.endsWith('_Count') && !k.startsWith('Serial')) {
              const label = k.replace(/_Count$/, '').replace(/_/g, ' ');
              if (!isLabelEnabled(label)) return;
              wardTotals[k] = (wardTotals[k] || 0) + (parseInt(r[k]) || 0);
            }
          });
        });
        setReportTableData(overriddenRows);
        setDefectTotals(wardTotals);
      } else {
        setReportTableData(rows);
        // Filter totals through disabled labels config
        const filteredTotals = {};
        Object.entries(totals).forEach(([k, v]) => {
          const label = k.replace(/_Count$/, '').replace(/_/g, ' ');
          if (isLabelEnabled(label)) filteredTotals[k] = v;
        });
        setDefectTotals(filteredTotals);
      }

      const preparedData = prepareBarChartData(rows, isLabelEnabled);
      setChartData({
        series: preparedData.series,
        categories: preparedData.categories,
      });
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      console.log("API Error, Contact Admin");
    }
  };

  // Function to load data from the pavement/report endpoint
  const loadRoadTableDataFromEndpoint = async () => {
    try {
      setIsLoading(true);
      const listOfIds = JSON.parse(
        decodeURIComponent(searchParams.get("listOfIds"))
      );

      // Fetch road table data from the new endpoint
      const mappedTableData = await fetchRoadTableData(listOfIds);

      // Process the mapped data using existing setupTableData function
      const { rows, totals } = setupTableData(mappedTableData);
      setReportTableData(rows);
      // Filter totals through disabled labels config
      const filteredTotals = {};
      Object.entries(totals).forEach(([k, v]) => {
        const label = k.replace(/_Count$/, '').replace(/_/g, ' ');
        if (isLabelEnabled(label)) filteredTotals[k] = v;
      });
      setDefectTotals(filteredTotals);

      const preparedData = prepareBarChartData(rows, isLabelEnabled);
      setChartData({
        series: preparedData.series,
        categories: preparedData.categories,
      });

      // Set some default values for the UI
      setAllTables([
        {
          project_title_display: "Road from API",
          start_add: { add: rows[0]?.start_address || "Start Location" },
          end_add: { add: rows[0]?.end_address || "End Location" },
          road_length: "1.0",
          road_rating: rows[0]?.IRC_Rating || 85,
          created: new Date().toLocaleDateString(),
        },
      ]);

      const initialValues = {
        project_title_0: "Road from API",
        start_add_0: rows[0]?.start_address || "Start Location",
        end_add_0: rows[0]?.end_address || "End Location",
        road_length_0: "1.0",
      };
      setFieldValues(initialValues);

      setIsLoading(false);
    } catch (error) {
      console.log("Error loading road table data:", error);
      // Fallback to original data loading
      loadReportData();
    }
  };

  useEffect(() => {
    // Check if we should use the new endpoint or the original one
    const listOfIds = searchParams.get("listOfIds");
    if (listOfIds) {
      const ids = JSON.parse(decodeURIComponent(listOfIds));
      // You can add logic here to determine which endpoint to use
      // For now, we'll use the original endpoint as default
      loadReportData();
    }
  }, [searchParams]);

  const handleEditClick = (field, currentValue) => {
    setEditField(field);
    setFieldValues({
      ...fieldValues,
      [field]: currentValue,
    });
  };

  const handleInputChange = (event, field) => {
    setFieldValues({
      ...fieldValues,
      [field]: event.target.value,
    });
  };

  // Extract IRC Rating data with road names and chainage
  const extractIRCRatingData = () => {
    const extractedData = [];

    reportTableData.forEach((row) => {
      extractedData.push({
        serialNumber: row.number,
        roadName: fieldValues[`project_title_0`] || "Unknown Road",
        chainage: row.Chainage, // Format: "0-100", "100-200", etc.
        startAddress: row.start_address,
        endAddress: row.end_address,
        startCoordinates: `${row.start_latitude}, ${row.start_longitude}`,
        endCoordinates: `${row.end_latitude}, ${row.end_longitude}`,
        ircRating: row.IRC_Rating,
        roadCondition:
          row.IRC_Rating <= 40
            ? "Poor"
            : row.IRC_Rating <= 80
              ? "Fair"
              : "Good",
        defectDetails: {
          cracking: {
            count: row.Cracking_Count,
            severity: row.Cracking_Severity,
          },
          damagedFootpath: {
            count: row.Damaged_Footpath_Count,
            severity: row.Damaged_Footpath_Severity,
          },
          damagedKerbFadedPaint: {
            count: row.Damaged_Kerb_Faded_Paint_Count,
            severity: row.Damaged_Kerb_Faded_Paint_Severity,
          },
          damagedMissingCoverSlabs: {
            count: row.Damaged_Missing_Cover_Slabs_Count,
            severity: row.Damaged_Missing_Cover_Slabs_Severity,
          },
          deterioratedDamagedPlants: {
            count: row.Deteriorated_Damaged_Plants_Count,
            severity: row.Deteriorated_Damaged_Plants_Severity,
          },
          edgeDropUnevenShoulders: {
            count: row.Edge_Drop_Uneven_Shoulders_Count,
            severity: row.Edge_Drop_Uneven_Shoulders_Severity,
          },
          missingPlantsIrregularGaps: {
            count: row.Missing_Plants_Irregular_Gaps_Count,
            severity: row.Missing_Plants_Irregular_Gaps_Severity,
          },
          potholes: {
            count: row.Potholes_Count,
            severity: row.Potholes_Severity,
          },
          rainCutsShoulders: {
            count: row.Rain_Cuts_Shoulders_Count,
            severity: row.Rain_Cuts_Shoulders_Severity,
          },
          reducedVisibilityPlantGrowth: {
            count: row.Reduced_Visibility_Plant_Growth_Count,
            severity: row.Reduced_Visibility_Plant_Growth_Severity,
          },
          rutting: { count: row.Rutting_Count, severity: row.Rutting_Severity },
          vegetationGrowthShoulders: {
            count: row.Vegetation_Growth_Shoulders_Count,
            severity: row.Vegetation_Growth_Shoulders_Severity,
          },
          waterStagnation: {
            count: row.Water_Stagnation_Count,
            severity: row.Water_Stagnation_Severity,
          },
        },
      });
    });

    return extractedData;
  };

  // Export IRC data as CSV
  const exportIRCDataAsCSV = () => {
    const data = extractIRCRatingData();
    if (data.length === 0) {
      message.error("No data available to export");
      return;
    }

    const csvHeaders = [
      "Serial Number",
      "Road Name",
      "Chainage",
      "Start Address",
      "End Address",
      "Start Coordinates",
      "End Coordinates",
      "IRC Rating",
      "Road Condition",
    ];

    const csvRows = data.map((row) => [
      row.serialNumber,
      row.roadName,
      row.chainage,
      row.startAddress,
      row.endAddress,
      row.startCoordinates,
      row.endCoordinates,
      row.ircRating,
      row.roadCondition,
    ]);

    const csvContent = [csvHeaders, ...csvRows]
      .map((row) => row.map((field) => `"${field}"`).join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `IRC_Rating_Data_${new Date().toISOString().split("T")[0]
      }.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  // Log IRC data to console
  const logIRCData = () => {
    const data = extractIRCRatingData();
    console.log("IRC Rating Data:", data);
    message.success(
      `Extracted ${data.length} IRC rating records. Check console for details.`
    );
  };

  // Download report as PDF
  const downloadReportAsPDF = async () => {
    try {
      message.loading("Generating PDF report...", 0);

      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      let yPosition = 20;

      // Add header
      pdf.setFontSize(18);
      pdf.setFont("helvetica", "bold");
      pdf.text(`${APP_NAME} Road Inspection Report`, pageWidth / 2, yPosition, { align: "center" });
      yPosition += 10;

      // Add date
      pdf.setFontSize(10);
      pdf.setFont("helvetica", "normal");
      const reportDate = allTables[0]?.created || new Date().toLocaleDateString();
      pdf.text(`Report Date: ${reportDate}`, pageWidth / 2, yPosition, { align: "center" });
      yPosition += 15;

      // Add overview section
      pdf.setFontSize(14);
      pdf.setFont("helvetica", "bold");
      pdf.text("Overview", 14, yPosition);
      yPosition += 8;

      pdf.setFontSize(10);
      pdf.setFont("helvetica", "normal");
      if (allTables.length > 0) {
        const tableData = allTables[0];
        pdf.text(`Road Name: ${fieldValues.project_title_0 || tableData.project_title_display}`, 14, yPosition);
        yPosition += 6;
        pdf.text(`Starting Point: ${fieldValues.start_add_0 || tableData.start_add?.add}`, 14, yPosition);
        yPosition += 6;
        pdf.text(`Ending Point: ${fieldValues.end_add_0 || tableData.end_add?.add}`, 14, yPosition);
        yPosition += 6;
        pdf.text(`Road Length: ${tableData.road_length} KM`, 14, yPosition);
        yPosition += 6;
        pdf.text(`PCI Rating: ${tableData.road_rating} ${getRoadLevel(tableData.road_rating)}`, 14, yPosition);
        yPosition += 10;
      }

      // Add defect breakdown section
      pdf.setFontSize(14);
      pdf.setFont("helvetica", "bold");
      pdf.text("Defect Breakdown", 14, yPosition);
      yPosition += 8;

      // Group defects
      const groupedDefects = {};
      const normalizeDefectName = (name) => {
        let normalized = name.toLowerCase();
        if (normalized === 'potholes') normalized = 'pothole';
        if (normalized === 'cracks') normalized = 'crack';
        if (normalized === 'ruts') normalized = 'rut';
        return normalized.charAt(0).toUpperCase() + normalized.slice(1);
      };

      Object.keys(defectTotals)
        .filter(key => key.endsWith('_Count'))
        .filter(key => defectTotals[key] > 0)
        .forEach((defectKey) => {
          const defectName = defectKey
            .replace('_Count', '')
            .replace(/_/g, ' ')
            .replace(/\b\w/g, l => l.toUpperCase())
            .replace(/\s*(High|Medium|Low)\s*$/i, '')
            .trim();
          const normalizedName = normalizeDefectName(defectName);
          if (groupedDefects[normalizedName]) {
            groupedDefects[normalizedName] += defectTotals[defectKey];
          } else {
            groupedDefects[normalizedName] = defectTotals[defectKey];
          }
        });

      pdf.setFontSize(10);
      pdf.setFont("helvetica", "normal");
      let defectIndex = 0;
      for (const [defectName, defectValue] of Object.entries(groupedDefects)) {
        pdf.text(`${defectName}: ${defectValue}`, 14, yPosition);
        yPosition += 6;
        defectIndex++;
        if (yPosition > pageHeight - 20) {
          pdf.addPage();
          yPosition = 20;
        }
      }

      pdf.text(`Total Defects: ${totalDefectCount}`, 14, yPosition);
      yPosition += 15;

      // Add road analysis table
      if (yPosition > pageHeight - 60) {
        pdf.addPage();
        yPosition = 20;
      }

      pdf.setFontSize(14);
      pdf.setFont("helvetica", "bold");
      pdf.text("Road Analysis", 14, yPosition);
      yPosition += 5;

      // Prepare table data
      const tableHeaders = [
        "Serial No.",
        "Chainage (m)",
        "Start Address",
        "End Address",
        "PCI Value"
      ];

      const tableRows = reportTableData.map((row, index) => [
        row.Serial_Number || index + 1,
        row.Chainage,
        `${row.start_address}\n(${row.start_latitude}, ${row.start_longitude})`,
        `${row.end_address}\n(${row.end_latitude}, ${row.end_longitude})`,
        row.PCI || row.IRC_Rating || 0
      ]);

      pdf.autoTable({
        head: [tableHeaders],
        body: tableRows,
        startY: yPosition,
        theme: 'grid',
        styles: {
          fontSize: 8,
          cellPadding: 3
        },
        headStyles: {
          fillColor: [66, 84, 102],
          textColor: [255, 255, 255],
          fontStyle: 'bold'
        },
        margin: { left: 14, right: 14 }
      });

      yPosition = pdf.lastAutoTable.finalY + 15;

      // Add detailed defect information for each segment
      for (let i = 0; i < reportTableData.length; i++) {
        const row = reportTableData[i];

        if (yPosition > pageHeight - 40) {
          pdf.addPage();
          yPosition = 20;
        }

        pdf.setFontSize(12);
        pdf.setFont("helvetica", "bold");
        pdf.text(`Chainage ${row.Chainage} - Defect Details`, 14, yPosition);
        yPosition += 5;

        // Group defects for this segment (filtered by defect config)
        const segmentGroupedDefects = {};
        const defectKeys = Object.keys(row).filter(key => {
          if (!key.endsWith('_Count') || key.startsWith('Serial')) return false;
          const label = key.replace('_Count', '').replace(/_/g, ' ');
          return isLabelEnabled(label);
        });

        defectKeys
          .filter((defectKey) => parseInt(row[defectKey]) > 0)
          .forEach((defectKey) => {
            const defectName = defectKey
              .replace('_Count', '')
              .replace(/_/g, ' ')
              .replace(/\b\w/g, l => l.toUpperCase())
              .replace(/\s*(High|Medium|Low)\s*$/i, '')
              .trim();
            const normalizedName = normalizeDefectName(defectName);
            const severityKey = defectKey.replace('_Count', '_Severity');
            const count = parseInt(row[defectKey]) || 0;
            const severity = row[severityKey] || 'Nill';

            if (segmentGroupedDefects[normalizedName]) {
              segmentGroupedDefects[normalizedName].count += count;
              const severities = ['Nill', 'low', 'medium', 'high'];
              const currentSeverityIndex = severities.indexOf(segmentGroupedDefects[normalizedName].severity.toLowerCase());
              const newSeverityIndex = severities.indexOf(severity.toLowerCase());
              if (newSeverityIndex > currentSeverityIndex) {
                segmentGroupedDefects[normalizedName].severity = severity;
              }
            } else {
              segmentGroupedDefects[normalizedName] = { count, severity };
            }
          });

        if (Object.keys(segmentGroupedDefects).length > 0) {
          const defectTableHeaders = ["Defect Type", "Count", "Severity"];
          const defectTableRows = Object.entries(segmentGroupedDefects).map(([defectName, data]) => [
            defectName,
            data.count,
            data.severity
          ]);

          pdf.autoTable({
            head: [defectTableHeaders],
            body: defectTableRows,
            startY: yPosition,
            theme: 'striped',
            styles: {
              fontSize: 8,
              cellPadding: 2
            },
            headStyles: {
              fillColor: [66, 84, 102],
              textColor: [255, 255, 255],
              fontStyle: 'bold'
            },
            margin: { left: 14, right: 14 }
          });

          yPosition = pdf.lastAutoTable.finalY + 10;
        } else {
          pdf.setFontSize(9);
          pdf.setFont("helvetica", "normal");
          pdf.text("No defects found in this segment", 14, yPosition);
          yPosition += 10;
        }
      }

      // Save PDF
      const roadName = fieldValues.project_title_0 || allTables[0]?.project_title_display || 'Road';
      const fileName = `${roadName.replace(/[^a-z0-9]/gi, '_')}_Report_${new Date().toISOString().split('T')[0]}.pdf`;
      pdf.save(fileName);

      message.destroy();
      message.success("PDF report downloaded successfully!");
    } catch (error) {
      console.error("Error generating PDF:", error);
      message.destroy();
      message.error("Failed to generate PDF report. Please try again.");
    }
  };

  const handleSave = async () => {
    if (!editField) return;

    const fieldMapping = {
      project_title: "project_title_display",
      start_add: "start_add",
      end_add: "end_add",
    };

    const lastUnderscoreIndex = editField.lastIndexOf("_");
    const fieldKey = editField.substring(0, lastUnderscoreIndex);
    const fieldName = fieldMapping[fieldKey];

    try {
      const project_uid_list = JSON.parse(decodeURIComponent(listOfIds));
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}project/update_field`,
        {
          project_uid: project_uid_list,
          field: fieldName,
          value: fieldValues[editField],
        }
      );

      if (response.status === 200) {
        await loadReportData();
      }
    } catch (error) {
      console.error("Error updating field:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.result === "Admin privileges required"
      ) {
        notification.error({
          message: "Permission Denied",
          description: "Admin privileges required to perform this action.",
        });
      }
    } finally {
      setEditField(null);
    }
  };

  const totalDefectCount = useMemo(() =>
    Object.values(defectTotals).reduce((acc, current) => acc + current, 0),
    [defectTotals]
  );

  const getProgressColor = useCallback((rating) => {
    if (rating === 0) {
      return "#D71E10";
    } else if (rating <= 40) {
      return "#D71E10";
    } else if (rating <= 80) {
      return "#FD9900";
    } else {
      return "#17AB40";
    }
  }, []);

  const getRoadLevel = useCallback((rating) => {
    if (rating <= 40) {
      return "(Poor)";
    } else if (rating <= 80) {
      return "(Fair)";
    } else {
      return "(Good)";
    }
  }, []);

  const getRoadLevel2 = useCallback((rating) => {
    if (rating <= 40) {
      return "PCI 3";
    } else if (rating <= 80) {
      return "PCI 2";
    } else {
      return "PCI 1";
    }
  }, []);

  const colorsMap = useMemo(() => ({
    "High Severity": "#E91E63", // Red
    "Medium Severity": "#FF9800", // Orange
    "Not Defected": "#2E93fA", // Blue
    "Low Severity": "#66DA26", // Green
  }), []);

  const colors = useMemo(() =>
    pieChart2Data.labels
      ? pieChart2Data.labels.map((label) => colorsMap[label])
      : [],
    [pieChart2Data.labels, colorsMap]
  );

  const options = useMemo(() => ({
    chart: {
      type: "pie",
      width: 380,
      animations: {
        enabled: true,
        speed: 400,
        animateGradually: {
          enabled: false,
        },
      },
      toolbar: {
        show: true,
        tools: {
          download: true,
        },
      },
    },
    labels: pieChart2Data.labels || [],
    colors: colors,
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val.toLocaleString(undefined, { maximumFractionDigits: 1 }) + "%";
      },
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            position: "bottom",
            horizontalAlign: "start",
            fontSize: "8px",
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: false,
                  total: {
                    show: true,
                    label: "Total",
                  },
                },
              },
            },
          },
          tooltip: {
            y: {
              formatter: (val) => `${val.toLocaleString()} defects`,
            },
          },
        },
      },
    ],
  }), [pieChart2Data.labels, colors]);

  const options2 = useMemo(() => ({
    chart: {
      type: "bar",
      animations: {
        enabled: false,
      },
      toolbar: {
        show: true,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "60%",
        distributed: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: ['#2E93fA'],
    legend: {
      show: false,
    },
    stroke: {
      show: false,
    },
    xaxis: {
      categories: chartData.categories,
      title: {
        text: "Chainage (m)",
      },
      labels: {
        rotate: -45,
        rotateAlways: true,
        style: {
          fontSize: '10px',
        },
      },
    },
    yaxis: {
      title: {
        text: "Total Defects",
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: (val) => `${val.toLocaleString()} defects`,
      },
    },
  }), [chartData.categories]);

  const customFormat = useCallback((rating) => (
    <div className="flex flex-col items-center justify-between">
      <div className="text-sm font-semibold text-gray-500">
        {getRoadLevel2(rating)}
      </div>
      <div className="text-lg font-bold text-gray-800">{rating}</div>
    </div>
  ), [getRoadLevel2]);

  function containsMultipleIds(listOfIds) {
    try {
      const ids = JSON.parse(listOfIds);
      return Array.isArray(ids) && ids.length > 1;
    } catch (error) {
      return false;
    }
  }
  const listOfIds = searchParams.get("listOfIds");
  const menus = [
    {
      name: "Map",
      link:
        `${window.location.origin.toString()}/pavement/multiMap?listOfIds=` +
        searchParams.get("listOfIds"),
      icon: IoMapSharp,
    },
    {
      name: "Report",
      link: containsMultipleIds(listOfIds)
        ? "#"
        : `${window.location.origin.toString()}/pavement/report?listOfIds=${listOfIds}`,
      icon: RiArticleFill,
      onClick: containsMultipleIds(listOfIds)
        ? (event) => {
          event.preventDefault();
          alert("Please select only one project.");
        }
        : undefined,
    },
    // {
    //   name: "Safety Report",
    //   link: containsMultipleIds(listOfIds)
    //     ? "#"
    //     : `${window.location.origin.toString()}/safetyReports?listOfIds=${listOfIds}`,
    //   icon: FaRegFileLines,
    //   onClick: containsMultipleIds(listOfIds)
    //     ? (event) => {
    //       event.preventDefault();
    //       alert("Please select only one project.");
    //     }
    //     : undefined,
    // },
    {
      name: "Notifications",
      link:
        `${window.location.origin.toString()}/pavement/notifications?listOfIds=` +
        searchParams.get("listOfIds"),
      icon: RiNotification3Fill,
    },
    {
      name: "VersionControl",
      link: "#",
      icon: RiHistoryFill,
      onClick: (event) => {
        event.preventDefault();
        alert("Only Available For Enterprise Customers!");
      },
    },
    {
      name: "Budget Calculator",
      link:
        `${window.location.origin.toString()}/pavement/calculator?listOfIds=` +
        searchParams.get("listOfIds"),
      icon: RiCalculatorFill,
    },
    {
      name: "Download Report",
      link:
        `${window.location.origin.toString()}/pavement/multireport?listOfIds=` +
        searchParams.get("listOfIds"),
      icon: RiFileDownloadFill,
    },
    {
      name: "Traffic Management System",
      link:
        `${window.location.origin.toString()}/pavement/traffic?listOfIds=` +
        searchParams.get("listOfIds"),
      icon: RiTrafficLightLine,
    },
  ];
  return (
    <div className="w-full">
      {/* <div
        className="bg-gray-50 h-full w-[70px]
           text-[#425466] px-4 z-100 fixed"
      >
        <div className="mt-4 flex flex-col gap-4 relative">
          <Link to="/pavement/app" className="mb-2 logo">
            <img src={brandingSettings.logo} alt="Logo" className="w-16 h-auto object-contain" />
          </Link>
          {menus?.map((menu, i) => {
            return (
              <Link
                to={menu.link}
                key={i}
                className={` ${menu?.margin && "mt-5"
                  } group flex items-center text-sm  gap-3 font-medium p-2 hover:bg-slate-200 rounded-md`}
                title={menu.name}
                onClick={menu.onClick}
              >
                <div>{React.createElement(menu?.icon, { size: "21" })}</div>
              </Link>
            );
          })}
        </div>
      </div> */}

      {isLoading ? (
        <div className="">
          <LoadingScreen />
        </div>
      ) : (
        <div className="flex flex-col w-full bg-white">
          <div className="flex w-full justify-around px-8 items-center h-16 shadow-md sticky top-0 z-40 bg-white">
            <div className="center_profile">
              <p className="text-lg font-semibold text-gray-800">
                {APP_NAME} Road Inspection Report
              </p>
            </div>
            <div className="right_profile">
              <div className="flex gap-4 items-center">
                {/* <button
                  onClick={downloadReportAsPDF}
                  className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors shadow-sm"
                  title="Download PDF Report"
                >
                  <RiFileDownloadFill size={16} className="mr-2" />
                  Download PDF
                </button> */}
                <div className="flex gap-2">
                  <div className="flex items-center">
                    <MdCalendarMonth size="20" />
                  </div>
                  <div className="flex items-center">
                    {allTables.map((tableData) => (
                      <p className="text-sm text-gray-800">
                        {isLoading ? (
                          <Skeleton.Input active size="small" />
                        ) : (
                          <p>{tableData.created}</p>
                        )}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="header flex flex-col p-8">
            <div className="flex gap-4 w-full items-stretch max-w-screen-l mx-auto">
              <div className="dashboard-box w-full lg:w-1/3 bg-white shadow-md border border-gray-300 flex items-stretch">
                <div className="flex flex-col w-full gap-8">
                  <div className="flex flex-col gap-4 bg-white p-4 shadow-md border border-gray-200 h-full">
                    <p className="text-lg font-semibold text-gray-800">
                      Overview
                    </p>
                    {allTables.map((tableData, index) => (
                      <div key={index} className="flex flex-col gap-4">
                        {editField === `project_title_${index}` ? (
                          <TextField
                            fullWidth
                            type="text"
                            value={fieldValues[`project_title_${index}`]}
                            onChange={(e) =>
                              handleInputChange(e, `project_title_${index}`)
                            }
                            autoFocus
                            className="bg-[#F0F5FE]"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <div className="flex space-x-4">
                                    <div
                                      className="text"
                                      style={{
                                        color: "#1967D2",
                                        cursor: "pointer",
                                      }}
                                      onClick={handleSave}
                                    >
                                      Save
                                    </div>
                                  </div>
                                </InputAdornment>
                              ),
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: 40,
                                borderRadius: 2,
                              },
                              "& .MuiInputBase-input": {
                                padding: "8px 2px",
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: "transparent",
                                  borderRadius: 2,
                                },
                                "&:hover fieldset": {
                                  borderColor: "black",
                                  borderRadius: 2,
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "#80d4ff",
                                  borderRadius: 2,
                                },
                              },
                            }}
                          />
                        ) : (
                          <div className="flex items-center justify-between">
                            <p className="text-sm font-semibold text-gray-500">
                              Road Name
                              <span className="text-gray-800 ml-2">
                                {fieldValues[`project_title_${index}`]}
                              </span>
                            </p>
                            <button
                              className="ml-2 text-[#1967D2]"
                              onClick={() =>
                                handleEditClick(
                                  `project_title_${index}`,
                                  tableData.project_title_display
                                )
                              }
                            >
                              <RiEdit2Line />
                            </button>
                          </div>
                        )}
                        {editField === `start_add_${index}` ? (
                          <TextField
                            fullWidth
                            type="text"
                            value={fieldValues[`start_add_${index}`]}
                            onChange={(e) =>
                              handleInputChange(e, `start_add_${index}`)
                            }
                            autoFocus
                            className="bg-[#F0F5FE]"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <div className="flex space-x-4">
                                    <div
                                      className="text"
                                      style={{
                                        color: "#1967D2",
                                        cursor: "pointer",
                                      }}
                                      onClick={handleSave}
                                    >
                                      Save
                                    </div>
                                  </div>
                                </InputAdornment>
                              ),
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: 40,
                                borderRadius: 2,
                              },
                              "& .MuiInputBase-input": {
                                padding: "8px 2px",
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: "transparent",
                                  borderRadius: 2,
                                },
                                "&:hover fieldset": {
                                  borderColor: "black",
                                  borderRadius: 2,
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "#80d4ff",
                                  borderRadius: 2,
                                },
                              },
                            }}
                          />
                        ) : (
                          <div className="flex items-center justify-between">
                            <p className="text-sm font-semibold text-gray-500">
                              Starting Point
                              <span className="text-gray-800 ml-2">
                                {fieldValues[`start_add_${index}`]}
                              </span>
                            </p>
                            <button
                              className="ml-2 text-[#1967D2]"
                              onClick={() =>
                                handleEditClick(
                                  `start_add_${index}`,
                                  tableData.start_add.add
                                )
                              }
                            >
                              <RiEdit2Line />
                            </button>
                          </div>
                        )}
                        {editField === `end_add_${index}` ? (
                          <TextField
                            fullWidth
                            type="text"
                            value={fieldValues[`end_add_${index}`]}
                            onChange={(e) =>
                              handleInputChange(e, `end_add_${index}`)
                            }
                            autoFocus
                            className="bg-[#F0F5FE]"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <div className="flex space-x-4">
                                    <div
                                      className="text"
                                      style={{
                                        color: "#1967D2",
                                        cursor: "pointer",
                                      }}
                                      onClick={handleSave}
                                    >
                                      Save
                                    </div>
                                  </div>
                                </InputAdornment>
                              ),
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: 40,
                                borderRadius: 2,
                              },
                              "& .MuiInputBase-input": {
                                padding: "8px 2px",
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: "transparent",
                                  borderRadius: 2,
                                },
                                "&:hover fieldset": {
                                  borderColor: "black",
                                  borderRadius: 2,
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "#80d4ff",
                                  borderRadius: 2,
                                },
                              },
                            }}
                          />
                        ) : (
                          <div className="flex items-center justify-between">
                            <p className="text-sm font-semibold text-gray-500">
                              Ending Point
                              <span className="text-gray-800 ml-2">
                                {fieldValues[`end_add_${index}`]}
                              </span>
                            </p>
                            <button
                              className="ml-2 text-[#1967D2]"
                              onClick={() =>
                                handleEditClick(
                                  `end_add_${index}`,
                                  tableData.end_add.add
                                )
                              }
                            >
                              <RiEdit2Line />
                            </button>
                          </div>
                        )}
                        <p className="text-sm font-semibold text-gray-500">
                          Road Length
                          <span className="text-gray-800 ml-2">
                            {tableData.road_length} KM
                          </span>
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="dashboard-box w-2/3 bg-white shadow-md border border-gray-300 flex items-center">
                <div className="flex flex-col w-2/3">
                  <div className="flex flex-col gap-4 bg-white p-4 shadow-md border border-gray-200">
                    <p className="text-lg font-semibold text-gray-800">
                      Defect Breakdown
                    </p>
                    <div className="flex flex-col mb-2 max-h-96 overflow-y-auto">
                      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                        {(() => {
                          // Group defects by base name (without severity) and sum their counts
                          const groupedDefects = {};

                          // Helper function to normalize defect names (handle plural/singular)
                          const normalizeDefectName = (name) => {
                            let normalized = name.toLowerCase();
                            // Convert common plural forms to singular
                            if (normalized === 'potholes') normalized = 'pothole';
                            if (normalized === 'cracks') normalized = 'crack';
                            if (normalized === 'ruts') normalized = 'rut';
                            // Return with proper capitalization
                            return normalized.charAt(0).toUpperCase() + normalized.slice(1);
                          };

                          Object.keys(defectTotals)
                            .filter(key => key.endsWith('_Count'))
                            .filter(key => defectTotals[key] > 0)
                            .forEach((defectKey) => {
                              const defectName = defectKey
                                .replace('_Count', '')
                                .replace(/_/g, ' ')
                                .replace(/\b\w/g, l => l.toUpperCase())
                                .replace(/\s*(High|Medium|Low)\s*$/i, '')
                                .trim();

                              const normalizedName = normalizeDefectName(defectName);

                              if (groupedDefects[normalizedName]) {
                                groupedDefects[normalizedName] += defectTotals[defectKey];
                              } else {
                                groupedDefects[normalizedName] = defectTotals[defectKey];
                              }
                            });

                          return Object.entries(groupedDefects).map(([defectName, defectValue]) => (
                            <div key={defectName} className="flex flex-col p-3 bg-gray-50 rounded-md border border-gray-200 hover:shadow-sm transition-shadow">
                              <p className="text-xs font-medium text-gray-600 mb-1 line-clamp-2">
                                {defectName}
                              </p>
                              <p className="text-lg font-bold text-blue-600">
                                {defectValue.toLocaleString()}
                              </p>
                            </div>
                          ));
                        })()}
                      </div>
                    </div>
                    <p className="text-lg font-semibold text-gray-800">
                      Total Defect
                      <span className="text-gray-800 ml-2">
                        {totalDefectCount.toLocaleString()}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="flex flex-col w-1/3">
                  <div className="bg-gray-100 p-4 shadow-md border border-gray-200">
                    <p className="text-lg font-semibold text-gray-800 mb-8">
                      PCI Rating
                    </p>
                    {allTables.map((tableData, index) => (
                      <div key={index} className="flex items-center gap-2">
                        <Progress
                          type="circle"
                          percent={
                            tableData.road_rating === 0
                              ? 100
                              : tableData.road_rating * 33.33
                          }
                          strokeColor={getProgressColor(tableData.road_rating)}
                          format={() => customFormat(tableData.road_rating)}
                          size={150}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex mt-4 gap-4 w-full items-center">
              <div className="w-full bg-white p-4 rounded-md shadow-md border border-gray-300 overflow-hidden">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="border-r border-gray-300 pr-4">
                    <p className="text-small font-semibold text-gray-800 mb-4">
                      Severity Breakdown
                    </p>
                    {isLoading ? (
                      <Skeleton.Image active />
                    ) : (
                      <div style={{ height: '350px' }}>
                        <ReactApexChart
                          options={options}
                          series={pieChart2Data.series}
                          type="pie"
                          height={350}
                        />
                      </div>
                    )}
                  </div>
                  <div className="pl-4">
                    <p className="text-small font-semibold text-gray-800 mb-4">
                      Distribution of Defects per Chainage (100m intervals)
                    </p>
                    {isLoading ? (
                      <Skeleton.Image active />
                    ) : (
                      <div style={{ height: '350px', overflowX: 'auto' }}>
                        <ReactApexChart
                          options={options2}
                          series={chartData.series}
                          type="bar"
                          height={350}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex mt-4 gap-4 w-full items-center">
              <div className="defect-table-box w-full flex flex-col bg-white p-4 rounded-md shadow-md border border-gray-300">
                <p className="text-small mb-4 font-semibold text-gray-800">
                  Road Analysis
                </p>
                {isLoading ? (
                  <Skeleton active />
                ) : (
                  <TableContainer component={Paper}>
                    <Table aria-label="collapsible table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Serial No.</TableCell>
                          <TableCell>Chainage(m)</TableCell>
                          <TableCell>Start Address(Lat & Long)</TableCell>
                          <TableCell>End Address(Lat & Long)</TableCell>
                          <TableCell>Defect</TableCell>
                          <TableCell>Road Rating</TableCell>
                          <TableCell>PCI Value</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {reportTableData.map((row, index) => (
                          <React.Fragment key={index}>
                            <TableRow
                              key={row.number}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell component="th" scope="row">
                                {row.Serial_Number || index + 1}
                              </TableCell>
                              <TableCell>{row.Chainage}</TableCell>
                              <TableCell>
                                <div>{row.start_address}</div>
                                <div>
                                  ({row.start_latitude}, {row.start_longitude})
                                </div>
                              </TableCell>
                              <TableCell>
                                <div>{row.end_address}</div>
                                <div>
                                  ({row.end_latitude}, {row.end_longitude})
                                </div>
                              </TableCell>
                              <TableCell>
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    setOpen(open === index ? false : index)
                                  }
                                >
                                  {open === index ? (
                                    <KeyboardArrowUpIcon />
                                  ) : (
                                    <KeyboardArrowDownIcon />
                                  )}
                                </IconButton>
                              </TableCell>
                              <TableCell>
                                <div className="flex items-center gap-2">
                                  <Progress
                                    type="circle"
                                    percent={
                                      (row.PCI || row.IRC_Rating) === 0
                                        ? 100
                                        : row.PCI || row.IRC_Rating
                                    }
                                    strokeColor={getProgressColor(
                                      row.PCI || row.IRC_Rating
                                    )}
                                    size={20}
                                  />
                                  {getRoadLevel(row.PCI || row.IRC_Rating)}
                                </div>
                              </TableCell>
                              <TableCell>
                                {row.PCI || row.IRC_Rating || 0}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                style={{ paddingBottom: 0, paddingTop: 0 }}
                                colSpan={7}
                              >
                                <Collapse
                                  in={open === index}
                                  timeout="auto"
                                  unmountOnExit
                                >
                                  <Box margin={1}>
                                    <Table size="small" aria-label="details">
                                      <TableHead>
                                        <TableRow>
                                          <TableCell>Defect Type</TableCell>
                                          <TableCell>Count</TableCell>
                                          <TableCell>Severity</TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {(() => {
                                          console.log('=== ROAD ANALYSIS RENDERING ===');
                                          console.log('Row data:', row);
                                          const defectKeys = Object.keys(row).filter(key => {
                                            if (!key.endsWith('_Count') || key.startsWith('Serial')) return false;
                                            const label = key.replace('_Count', '').replace(/_/g, ' ');
                                            return isLabelEnabled(label);
                                          });
                                          console.log('Defect keys found:', defectKeys);

                                          // Helper function to normalize defect names (handle plural/singular)
                                          const normalizeDefectName = (name) => {
                                            let normalized = name.toLowerCase();
                                            // Convert common plural forms to singular
                                            if (normalized === 'potholes') normalized = 'pothole';
                                            if (normalized === 'cracks') normalized = 'crack';
                                            if (normalized === 'ruts') normalized = 'rut';
                                            // Return with proper capitalization
                                            return normalized.charAt(0).toUpperCase() + normalized.slice(1);
                                          };

                                          // Group defects by base name and aggregate counts and severities
                                          const groupedDefects = {};

                                          defectKeys
                                            .filter((defectKey) => parseInt(row[defectKey]) > 0)
                                            .forEach((defectKey) => {
                                              const defectName = defectKey
                                                .replace('_Count', '')
                                                .replace(/_/g, ' ')
                                                .replace(/\b\w/g, l => l.toUpperCase())
                                                .replace(/\s*(High|Medium|Low)\s*$/i, '')
                                                .trim();

                                              const normalizedName = normalizeDefectName(defectName);

                                              const severityKey = defectKey.replace('_Count', '_Severity');
                                              const count = parseInt(row[defectKey]) || 0;
                                              const severity = row[severityKey] || 'Nill';

                                              if (groupedDefects[normalizedName]) {
                                                groupedDefects[normalizedName].count += count;
                                                // Keep track of the highest severity
                                                const severities = ['Nill', 'low', 'medium', 'high'];
                                                const currentSeverityIndex = severities.indexOf(groupedDefects[normalizedName].severity.toLowerCase());
                                                const newSeverityIndex = severities.indexOf(severity.toLowerCase());
                                                if (newSeverityIndex > currentSeverityIndex) {
                                                  groupedDefects[normalizedName].severity = severity;
                                                }
                                              } else {
                                                groupedDefects[normalizedName] = { count, severity };
                                              }
                                            });

                                          return Object.entries(groupedDefects).map(([defectName, data]) => {
                                            console.log(`Rendering defect: ${defectName}, Count: ${data.count}, Severity: ${data.severity}`);

                                            return (
                                              <TableRow key={defectName}>
                                                <TableCell>{defectName}</TableCell>
                                                <TableCell>{data.count}</TableCell>
                                                <TableCell>{data.severity}</TableCell>
                                              </TableRow>
                                            );
                                          });
                                        })()}
                                      </TableBody>
                                    </Table>
                                  </Box>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Reports;
